import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Fades its content in the first time it scrolls into view, then stays visible.
 */
class FadeInView extends Component {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    super.connectedCallback();

    if (prefersReducedMotion()) {
      this.dataset.active = '';
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          this.dataset.active = '';
          this.#observer?.disconnect();
          this.#observer = null;
        }
      },
      { threshold: 0.1 }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('fade-in-view')) {
  customElements.define('fade-in-view', FadeInView);
}
